var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 39.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#969696;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rgMtye.tif"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    className: "cls-1",
    d: "M18.84,12.18c.43.16.52.48.52.9,0,1.84,0,3.67,0,5.5a.7.7,0,0,1-.17.52.68.68,0,0,1-.5.22H12.89a.71.71,0,0,1-.68-.51V12.69a.76.76,0,0,1,.52-.51ZM18,13.49H13.52V18H18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    className: "cls-1",
    d: "M27.79,18.81a.77.77,0,0,1-.83.52H21.41a.68.68,0,0,1-.76-.77V13a.74.74,0,0,1,.51-.82h6.11a.74.74,0,0,1,.52.51ZM26.48,13.5H22V18h4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    className: "cls-1",
    d: "M12.21,21.13a.77.77,0,0,1,.83-.52c1.85,0,3.7,0,5.55,0a.7.7,0,0,1,.77.62.61.61,0,0,1,0,.19c0,.49,0,1,0,1.48v4a.74.74,0,0,1-.51.83H12.73a.76.76,0,0,1-.52-.52ZM18,26.45V21.93H13.53v4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    className: "cls-1",
    d: "M21.15,27.76a.78.78,0,0,1-.51-.83c0-1.85,0-3.7,0-5.55a.67.67,0,0,1,.56-.76.74.74,0,0,1,.21,0H27a.74.74,0,0,1,.83.51v6.11a.76.76,0,0,1-.52.52Zm.8-1.31h4.53V21.93H22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    className: "cls-1",
    d: "M12.73,12.18a.76.76,0,0,0-.52.52v-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    className: "cls-1",
    d: "M27.79,12.7a.77.77,0,0,0-.52-.52h.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    className: "cls-1",
    d: "M12.21,27.24a.77.77,0,0,0,.52.52h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    className: "cls-1",
    d: "M27.27,27.76a.79.79,0,0,0,.52-.52v.52Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.cdb0a8f7060c0cbfa2532e2acdbdd9d1.svg";
export { ForwardRef as ReactComponent };